import { graphql, useStaticQuery } from "gatsby";
import React, { useCallback } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Modal from "../modal";

const ProductNotesModal = ({ show, onHide, data }) => {
  const ref = useRef(null);
  const dialogRef = useRef(null);

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        close
      }
    }
  `);

  const clickBack = useCallback(
    (event) => {
      if (
        event.target !== dialogRef.current &&
        dialogRef.current &&
        !dialogRef.current.contains(event.target)
      ) {
        onHide();
      }
    },
    [onHide]
  );

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onHide();
      }
    },
    [onHide]
  );

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`cart-modal${show ? " show" : ""}`}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={show ? 0 : -1}
        role="dialog"
        aria-hidden={!show}
        onKeyDown={onKeyDown}
        onClick={clickBack}
      >
        <div
          ref={dialogRef}
          className="cart-modal__dialog cart-modal__dialog--productnotes"
          role="document"
        >
          <div className="text-left">
            <div className="cart-modal__title mt-3 mt-md-4">{data.titlePopUp}</div>
            <div
              className="cart-modal__abstract mt-3 mt-md-4"
              dangerouslySetInnerHTML={{ __html: data.textPopUp }}
            ></div>
            <button className="cart-modal__close mt-3 mt-md-4" onClick={onHide}>
              {labelManagerLabels.close}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProductNotesModal;
